import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { getData, nFormatter } from "../../../../../services";
import { defaultItems, NoDataCard, TenancyChart } from "../../../../../components/parts";
import { vacancyKeys } from "../../../../building/constants";

const bars = [
  {
    dataKey: "portfolio",
    fill: COLORS.spanishGray,
    barSize: 18,
    unit: "%",
  },
  {
    dataKey: "industry",
    fill: COLORS.darks[0][100],
    barSize: 18,
    unit: "%",
  },
];

const percentUnitBars = bars.map((bar) => ({ ...bar, unit: "%" }));

const defaultChartData = [
  {
    key: "unit_areas",
    title: "",
    suffix: "",
    suffixColor: COLORS.blue,
    chartData: [],
    name: "Units Area",
    bars: bars,
  },
  {
    key: "public_areas",
    title: "",
    suffix: "",
    suffixColor: COLORS.blue,
    chartData: [],
    name: "Public Areas",
    bars: bars,
  },
  {
    key: "public_leased",
    title: "",
    chartData: [],
    suffixColor: COLORS.blue,
    name: "Public Areas Vs. Leased Units",
    bars: percentUnitBars,
  },
  {
    key: "physical_vacancy",
    title: "",
    suffix: "",
    suffixColor: COLORS.silverSand[100],
    chartData: [],
    name: "Current Physical Vacancy",
    bars: bars,
  },
  {
    key: "economic_vacancy",
    title: "",
    suffix: "",
    suffixColor: COLORS.silverSand[100],
    chartData: [],
    name: "Current Economic Vacancy",
    bars: bars,
  },
];

const useStyles = makeStyles(() => ({}));

export const TenancyDataGraph = ({ id }) => {
  const classes = useStyles();
  const [chartData, setChartData] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    getData(`/praas/v1/buildings/charts/`, (data) => {
      defaultChartData.forEach((item) => {
        const { percent, ...obj } = data[item.key];
        const onlyZeroValues = obj.portfolio === (vacancyKeys.includes(item.key) ? null : 0);
        const titleValue = "square" in obj ? obj.square : obj.portfolio;
        item.suffix =
          (vacancyKeys.includes(item.key) && percent && onlyZeroValues) || !titleValue ? (
            <Typography component="span" style={{ marginLeft: 25, color: COLORS.silverSand[100] }}>
              {percent} %
            </Typography>
          ) : percent ? (
            `(${percent} %)`
          ) : null;
        item.chartData = [obj];
        item.title = !titleValue ? "" : `${nFormatter(titleValue)} ${user?.unit_system}`;
        item.checkValue = percent;
        item.onlyZeroValues = onlyZeroValues;
        item.titleColor = COLORS.silverSand[100];
        item.noDataColor = COLORS.silverSand[100];
      });
      setChartData(defaultChartData);
    });

    return () => setChartData([]);
  }, [id, cluster, segments, selectedCountries]);

  return (
    <Box className={classes.root}>
      {chartData.length ? (
        <ShaDowBox style={{ padding: "32px 0" }}>
          <TenancyChart
            chartData={chartData}
            checkTitleKeys={vacancyKeys}
            graphFooterItems={defaultItems.slice(1, 3)}
          />
        </ShaDowBox>
      ) : (
        <NoDataCard
          rootStyle={{ minHeight: 316 }}
          footerNames={["Avg. portfolio", "Avg. Industry"]}
        />
      )}
    </Box>
  );
};
